import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {path: '', redirectTo: 'ehs', pathMatch: 'full'},
  {path: '**', redirectTo: 'ehs', pathMatch: 'full'},
  {path: 'ehs', loadChildren: './ehs/ehs.module#EhsModule'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
